<template>
	<section
		:id="data?.anchor_id ? data.anchor_id : null"
		class="feature defaultSectionMargins"
		@touchstart="touchStart"
		@touchend="touchEnd">
		<div class="feature__ItemsWrapper">
			<div v-for="(item, index) in data.items" class="feature__Item" :class="{ isActive: index === activeTab }">
				<h2 v-text="item.title" />
				<FlarePicture
					:src="{
						1920: { src: item.image, width: 1440, height: 754, size: 'both', crop: 'fill' },
						1440: { src: item.image, width: 1100, height: 576, size: 'both', crop: 'fill' },
						1024: { src: item.image, width: 800, height: 420, size: 'both', crop: 'fill' },
					}"
					:alt="item.image?.alt" />

				<div class="container">
					<h3 v-text="item.subtitle" />
					<p v-text="item.description" />
					<div>
						<Button
							type="nuxt-link"
							:to="item.page?.sef ? item.page.sef : item.link"
							v-bind="buttonStyles"
							negative
							:external="item.external"
							>{{ item.cta_text }}</Button
						>
					</div>
				</div>
			</div>
		</div>

		<div class="feature__Tabs">
			<button
				v-for="(item, index) in data.items"
				@click="activeTab = index"
				class="feature__TabsItem"
				:class="{ isActive: index === activeTab }">
				{{ item.name }}
			</button>
		</div>
	</section>
</template>

<script setup>
	const props = defineProps({
		data: {},
	});
	const { template } = usePage();
	const activeTab = ref(0);

	const buttonStyles = computed(() => (template?.value === 'AccommodationDetail' ? { primary: true } : { secondary: true }));

	let touchstartX = 0;
	let touchendX = 0;

	function checkTouch() {
		if (touchendX < touchstartX && activeTab.value < props.data.items.length - 1) activeTab.value = activeTab.value + 1;
		else if(touchendX < touchstartX && activeTab.value === props.data.items.length - 1) activeTab.value = 0;
    else if(touchendX > touchstartX && activeTab.value === 0) activeTab.value = props.data.items.length - 1;
    else if(touchendX > touchstartX && activeTab.value > 0) activeTab.value = activeTab.value - 1;
	}

	function touchStart(e) {
		touchstartX = e.changedTouches[0].screenX;
	}

	function touchEnd(e) {
		touchendX = e.changedTouches[0].screenX;
		checkTouch();
	}
</script>

<style lang="scss">
	@import url('@/assets/styles/components/blocks/_feature.scss');
</style>
